<button
  class="info-application"
  [class]="{
   'info-application-btn': needChangelogModal(),
   'info-application-no-btn': !needChangelogModal()
  }"
  (click)="needChangelogModal() && handleChangelogOpenModal()"
>
  <span class="info-application-stage">
    {{ stage() || 'N/A' }}
  </span>
  <span class="separator">-</span>
  <span class="front-version">
    front {{ versionFront() || 'N/A' }}
  </span>
  <span class="separator">-</span>
  <span class="back-version">
    back {{ versionBack() || 'N/A' }}
  </span>
</button>
